import { computed, makeObservable } from "mobx";
import CatalogueItem from "./CatalogueItem"
import PopupsManager from "react-sdk/PopupsManager";
import { POPUPS } from "../AppState";

class Catalogue {
  forceClickBtn = false
  forceClickCB = null

  /** @type {Array<CatalogueItem>} */
  all = []

  constructor() {
    makeObservable(this, {
      unlocked: computed
    })
  }

  init(json) {
    this.all = json
    .filter(elem => elem.id).map(elem => new CatalogueItem(elem))
  }

  get roots() {
    return this.all.filter(i => !i.parent)
  }
  get ids() { return this.all.map(c => c.id)}


  get(id) { return this.all.find(c => c.id === id) }

  get unlocked() {
    return this.all.filter(item => !item.locked)
  }

  multiUnlock(idsArray, popupClosedCB) {


    const unlockeditems = idsArray
    .map(id => this.get(id))
    .filter(item => item.locked)

    idsArray.forEach(id => this.unlock(id))

    if(popupClosedCB && unlockeditems.length > 0) {
      PopupsManager.open(POPUPS.CATALOGUE_ITEM, unlockeditems, popupClosedCB)
    }
    else {
      popupClosedCB?.()
    }
  }


  unlock(id, popupClosedCB) {
    let item = this.get(id)
    if(item?.locked) {
      item.unlock(popupClosedCB)
    } else
      popupClosedCB?.()

    if (item.parent) {
      this.unlock(item.parent)
    }
  }

  stateToJson() {
    return this.unlocked.map((item) => { return {id: item.id, knowledge: item.knowledge} } )
  }
  stateFromJson(state) {
    if (state == null)
        return

    state.forEach(itemState => {
      let item = this.get(itemState.id)
      if(item) {
        item.unlock()
        item.knowledge = itemState.knowledge
      }
    })
  }

}


export default new Catalogue()